module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": ""
    }
  }, [_c('h2', [_vm._v("Import Print Template")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pb-2": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": Object.keys(_vm.types),
      "label": _vm.selectedCompany ? _vm.$lang.actions.selectPrintTemplateType : 'Select Company first',
      "disabled": !_vm.selectedCompany || _vm.templatesForImport.length === 0,
      "hint": _vm.importHint,
      "persistent-hint": "",
      "loading": _vm.loading
    },
    model: {
      value: (_vm.typeForImport),
      callback: function($$v) {
        _vm.typeForImport = $$v
      },
      expression: "typeForImport"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary",
      "disabled": !_vm.typeForImport
    },
    on: {
      "click": function($event) {
        return _vm.submitTemplateImport()
      }
    }
  }, [_vm._v("\n      Submit\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d936287c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/PrintTemplatesImportModal.vue
// module id = 599
// module chunks = 15